import { BindFancybox } from 'smg/fancybox';

// Shared behavior, not a page: any page that can show a lightbox opts in with
// `js: [fancybox]`, which resolves through [params.js] in hugo.toml. That's the
// static gallery/product-type/options layouts plus the account/cart/checkout/
// quote/order pages whose proofs arrive from the API. Nothing else binds
// fancybox, so a new page with lightbox anchors must carry the declaration.
// Fancybox.bind is delegated, which is what covers anchors added after load.
BindFancybox();
